<div class="main">
    <div class="loader" *ngIf="showLoader">
        <div class="load">
          <mat-spinner></mat-spinner>
        </div>
      </div>
    <div class="section">
        <div class="header">
            <span class="left">
              {{'orderDetails.order' | translate}} #{{orderDetails.order}}
            </span>
    
            <span class="right" style="margin-right: 15px; display: inline-flex;">
                {{'orderDetails.allocationTime' | translate}} : {{orderDetails.allocatedTime}}
              <i class="material-icons" (click)="closeDialog();">clear</i>
            </span>
    
          </div>
        <div class="body">
            <mat-card class="pickDropSection " >
                <div class="pickDropBody">
                    <div class="pickSection">
                        <div class="pickup" *ngFor="let pick of orderDetails.pickups; let i = index">
                            <span>
                              <label class="pick-icon">P{{i+1}}</label>
                            </span>
                            <div class="pickAddress">
                              <span class="location">
                                {{pick.loc_id.name}} - {{pick.loc_id.city}}
                              </span>
                              <div class="area">
                                  {{pick.loc_id.area}}
                              </div>
                              <div class="dateTime">
                                {{toShortDateTime(pick.date_time)}}
                              </div>
                              <div class="dateTime" *ngIf="pick.loc_id.contact_name && pick.loc_id.contact_name.length">
                                Contact Name : {{pick.loc_id.contact_name}}
                              </div>
                              <div class="dateTime" *ngIf="pick.loc_id.mobile && pick.loc_id.mobile.length">
                                Contact Mobile : {{pick.loc_id.mobile}}
                              </div>
                            </div>
                          </div>
                    </div>
                    <div class="dropSection">
                        <div class="drop" *ngFor="let drop of orderDetails.drops; let i = index">
                            <span>
                              <label class="drop-icon">D{{i+1}}</label>
                            </span>
                            <div class="dropAddress">
                              <span class="location">
                                {{drop.loc_id.name}} - {{drop.loc_id.city}}
                              </span>
                              <div class="area">
                                  {{drop.loc_id.area}}
                              </div>
                              <div class="dateTime">
                                {{toShortDateTime(drop.date_time)}}
                              </div>
                              <div class="dateTime" *ngIf="drop.loc_id.contact_name && drop.loc_id.contact_name.length">
                                Contact Name : {{drop.loc_id.contact_name}}
                              </div>
                              <div class="dateTime" *ngIf="drop.loc_id.mobile && drop.loc_id.mobile.length">
                                Contact Mobile : {{drop.loc_id.mobile}}
                              </div>
                            </div>
                          </div>
                    </div>
                </div>
            </mat-card>
            <mat-card class="otherDetails ">
              <div class="otherDetailsBody">
                <div class="leftSection">
                  <div class="detail">
                    <div class="label">
                      {{'orderDetails.shipper' | translate}} 
                    </div>
                    <div class="colon">
                      :
                    </div>
                    <div class="value">
                      {{orderDetails.shipper.parent_name}} - {{orderDetails.shipper.name}}
                    </div>
                  </div>
                  <div class="detail">
                    <div class="label">
                      {{'orderDetails.materials' | translate}}    
                    </div>
                    <div style="padding-left: 40px;">
                      
                    </div>
                    <div class="colon" style="position: relative;right: 8%;">
                      :
                    </div>
                    <div class="value" *ngIf="orderDetails.materials.length">
                      <span *ngFor="let item of orderDetails.materials; let i=index">
                        {{item.name}}
                        <br>
                        <span *ngIf="(orderDetails.materials.length > 1) && (i != orderDetails.materials.length-1)">, </span>
                      </span>
                    </div>
                    <span class="value" *ngIf="!orderDetails.materials.length">
                      --
                    </span>
                  </div>
                  <div class="detail">
                    <div class="label">
                      {{'orderDetails.permits' | translate}}
                    </div>
                    <div class="colon">
                      :
                    </div>
                    <div class="value" *ngIf="orderDetails.permits.length">
                      <span *ngFor="let item of orderDetails.permits; let i=index">
                        {{item.name}}
                        <span *ngIf="(orderDetails.permits.length > 1) && (i != orderDetails.permits.length-1)">, </span>
                      </span>
                    </div>
                    <span class="value" *ngIf="!orderDetails.permits.length">
                      --
                    </span>
                  </div>
                  <div class="detail" style="min-height:20px">
                    <div class="label">
                      {{'orderDetails.noOfPackages' | translate}}
                    </div>
                    <div class="colon">
                      :
                    </div>
                    <div class="value">
                      {{orderDetails.packages}}
                    </div>
                  </div>
                  <div class="detail" style="text-align: center;min-height:20px">
                    <div style="padding-left: 40px;">
                      <strong>
                        or
                      </strong> 
                    </div>
                  </div>
                  <div class="detail">
                    <div class="label">
                      {{'orderDetails.cbm' | translate}} <br> 
                      <div style="color: #999999;">
                        {{'orderDetails.cubic' | translate}}
                      </div>
                      
                    </div>
                    <div class="colon">
                      :
                    </div>
                    <div class="value">
                      {{orderDetails.cbm}}
                    </div>
                  </div>
                  <div class="detail">
                    <div class="label">
                      {{'orderDetails.bidding' | translate}}
                    </div>
                    <div class="colon">
                      :
                    </div>
                    <div class="value">
                      {{orderDetails.bidding}}
                    </div>
                  </div>
                  <div class="detail" *ngIf="orderDetails.bidding == 'Yes'">
                    <div class="label">
                      {{'orderDetails.paymentTerm' | translate}}
                    </div>
                    <div class="colon">
                      :
                    </div>
                    <div class="value">
                      {{paymentTerm}}
                    </div>
                  </div>
                  <div class="detail" *ngIf="orderDetails.projectCodes">
                    <div class="label">
                      {{'orderDetails.projectCode' | translate}}
                    </div>
                    <div class="colon">
                      :
                    </div>
                    <div class="value">
                      {{orderDetails.projectCodes}}
                    </div>
                  </div>
                </div>
                <div class="rightSection">
                  <div class="detail">
                    <div class="label">
                      {{'orderDetails.vehicle' | translate}}
                    </div>
                    <div class="colon">
                      :
                    </div>
                    <div class="value">
                      {{orderDetails.vehicle}}
                    </div>
                  </div>
                  <div class="detail">
                    <div class="label">
                      <span *ngIf="orderDetails.allocation_type !== 'weight'">{{'orderDetails.shipmentWeight' | translate}} </span>
                      <span *ngIf="orderDetails.allocation_type == 'weight'">{{'orderDetails.total' | translate}} ({{ orderDetails.uom }}) </span><br> 
                      <br> 
                      <div style="color: #999999;">
                        <span *ngIf="orderDetails.uom && orderDetails.allocation_type !== 'weight'">
                          {{'orderDetails.perVehicle' | translate}} ({{ orderDetails.uom }})
                        </span>
                        <span *ngIf="!orderDetails.uom">
                          {{'orderDetails.perWeight' | translate}}
                        </span>
                      </div>
                    </div>
                    <div class="colon">
                      :
                    </div>
                    <div class="value">
                      {{orderDetails.shipmentWeight}}
                    </div>
                  </div>
                  <div class="detail">
                    <div class="label">
                      {{'orderDetails.purchase_order' | translate}}
                    </div>
                    <div class="colon">
                      :
                    </div>
                    <div class="value" *ngIf="orderDetails.purchase_order.length">
                      <span *ngFor="let item of orderDetails.purchase_order; let i=index">
                        {{item.name}}
                        <span *ngIf="(orderDetails.purchase_order.length > 1) && (i != orderDetails.purchase_order.length-1)">, </span>
                      </span>
                    </div>
                    <span class="value" *ngIf="!orderDetails.purchase_order.length">
                      --
                    </span>
                  </div>
                  <div class="detail">
                    <div class="label">
                      {{'orderDetails.segment' | translate}}
                    </div>
                    <div class="colon">
                      :
                    </div>
                    <div class="value" *ngIf="orderDetails.segmentation.length">
                      <span *ngFor="let item of orderDetails.segmentation; let i=index">
                        {{item.name}}
                        <span *ngIf="(orderDetails.segmentation.length > 1) && (i != orderDetails.segmentation.length-1)">, </span>
                      </span>
                    </div>
                    <span class="value" *ngIf="!orderDetails.segmentation.length">
                      --
                    </span>
                  </div>
                  <div class="detail">
                    <div class="label">
                      {{'orderDetails.accessories' | translate}}
                      
                    </div>
                    <div class="colon">
                      :
                    </div>
                    <div class="value" *ngIf="orderDetails.accessories.length">
                      <span *ngFor="let item of orderDetails.accessories; let i=index">
                        {{item.name}}
                        <span *ngIf="(orderDetails.accessories.length > 1) && (i != orderDetails.accessories.length-1)">, </span>
                      </span>
                    </div>
                    <span class="value" *ngIf="!orderDetails.accessories.length">
                      --
                    </span>
                  </div
                  >
                  <div class="detail">
                    <div class="label">
                      {{'orderDetails.docs' | translate}}
                      
                    </div>
                    <div class="colon">
                      :
                    </div>
                    <div class="value" *ngIf="orderDetails.documents.length">
                      <span *ngFor="let item of orderDetails.documents; let i=index">
                        <a href="{{item.link}}" class="icon">
                          <img *ngIf="item.extension == 'png' || item.extension == 'jpg' || item.extension == 'jpeg || item.extension == 'gif" class="image" src="assets/image-icon.svg">
                          <img *ngIf="item.extension == 'pdf'" class="image" src="assets/PDF-icon.svg">
                          <img *ngIf="item.extension == 'doc' || item.extension == 'csv' || item.extension == 'docx' || item.extension == 'txt' || item.extension == 'xlsx'" class="image" src="assets/Doc-icon.svg">
                        </a>
                        <span *ngIf="(orderDetails.documents.length > 1) && (i != orderDetails.documents.length-1)">, </span>
                      </span>
                    </div>
                    <span class="value" *ngIf="!orderDetails.documents.length"> 
                      --
                    </span>
                </div>
                  <div class="detail">
                    <div class="label">
                      {{'orderDetails.comments' | translate}}
                    </div>
                    <div class="colon">
                      :
                    </div>
                    <div class="value">
                      {{orderDetails.comments}}
                    </div>
                  </div>
                  <div class="detail" *ngIf="orderDetails.lcExpiryDate">
                    <div class="label">
                      {{'orderDetails.lcExpiryDate' | translate}}
                    </div>
                    <div class="colon">
                      :
                    </div>
                    <div class="value">
                      {{orderDetails.lcExpiryDate}}
                    </div>
                  </div>
                </div>
              </div>
            </mat-card>
        </div>
    </div>
</div>